class DateRangePickerCreator {
  static daterangepicker_ranges_config = {
    'en': {
      'today': 'Today',
      'yesterday': 'Yesterday',
      'last_seven_days': 'Last 7 Days',
      'last_thirty_days': 'Last 30 Days',
      'this_month': 'This Month',
      'last_month': 'Last Month'
    },
    'de': {
      'today': 'Heute',
      'yesterday': 'Gestern',
      'last_seven_days': 'Die letzten 7 Tage',
      'last_thirty_days': 'Die letzten 30 Tage',
      'this_month': 'Aktueller Monat',
      'last_month': 'Letzter Monat'
    }
  };

  static daterangepicker_locale_config = {
    'de': {
      'format': 'DD.MM.YYYY HH:mm',
      'separator': ' - ',
      'applyLabel': 'OK',
      'cancelLabel': 'Abbrechen',
      'customRangeLabel': 'Eigener Zeitraum',
      'weekLabel': 'W',
      'daysOfWeek': ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      'monthNames': ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
      'firstDay': 1
    },
    'en': {
      'format': 'YYYY/MM/DD HH:mm',
      'separator': ' - ',
      'applyLabel': 'Apply',
      'cancelLabel': 'Cancel',
      'customRangeLabel': 'Custom',
      'weekLabel': 'W',
      'daysOfWeek': ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
      'monthNames': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      'firstDay': 1
    }
  };

  static future_single_date_locale_config = {
    'de': {
      'format': 'DD.MM.YYYY'
    },
    'en': {
      'format': 'YYYY/MM/DD'
    }
  };

  constructor(locale) {
    this.locale = locale;
  }

  short_date_format_config() {
    return DateRangePickerCreator.future_single_date_locale_config[locale]
  }

  daterangepicker_locale(options) {
    return $.extend({}, DateRangePickerCreator.daterangepicker_locale_config[locale], options)
  }

  daterangepicker_ranges() {
    return DateRangePickerCreator.daterangepicker_ranges_config[locale]
  }

  future_single_daterangepicker_locale() {
    return $.extend({}, DateRangePickerCreator.daterangepicker_locale_config[locale], DateRangePickerCreator.future_single_date_locale_config[locale]);
  }

  create_pickers(finder_expression, options) {
    let obj = {};
    let picker_config = {
      'timePicker': true,
      'timePicker24Hour': true,
      'alwaysShowCalendars': false,
      'ranges': (
        obj["" + (this.daterangepicker_ranges()['today'])] = [moment().startOf('day'), moment()],
        obj["" + (this.daterangepicker_ranges()['yesterday'])] = [moment().subtract(1, 'days').startOf('day'), moment().startOf('day')],
        obj["" + (this.daterangepicker_ranges()['last_seven_days'])] = [moment().subtract(6, 'days').startOf('day'), moment()],
        obj["" + (this.daterangepicker_ranges()['last_thirty_days'])] = [moment().subtract(29, 'days').startOf('day'), moment()],
        obj["" + (this.daterangepicker_ranges()['this_month'])] = [moment().startOf('month'), moment()],
        obj["" + (this.daterangepicker_ranges()['last_month'])] = [moment().subtract(1, 'months').startOf('month'), options['timePicker'] === false ? moment().subtract(1, 'months').endOf('month') : moment().startOf('month')],
        obj
      ),
      'locale': this.daterangepicker_locale(options),
      'startDate': moment().add(-4, 'days').startOf('day'),
      'endDate': moment(),
      'maxDate': moment().endOf('day')
    };
    picker_config = $.extend({}, picker_config, options);
    $(finder_expression).daterangepicker(picker_config, function (start, end, label) { });
    $('.calendar.left').prepend("<div class='calendar-header'>" + this.daterangepicker_locale()["left"] + "</div>");
    $('.calendar.right').prepend("<div class='calendar-header'>" + this.daterangepicker_locale()["right"] + "</div>");
  }

  create_single_date_pickers(finder_expression, options) {
    let picker_config = {
      'autoUpdateInput': false,
      'singleDatePicker': true,
      'timePicker': true,
      'timePicker24Hour': true,
      'locale': this.daterangepicker_locale(),
      'startDate': moment().add(-1, 'days').startOf('day'),
      'endDate': moment(),
      'maxDate': moment().add(1, 'days').endOf('day')
    };
    picker_config = $.extend({}, picker_config, options);
    $(finder_expression).daterangepicker(picker_config, function (start, end, label) { });
  }

  create_future_date_without_time_pickers(finder_expression) {
    $(finder_expression).daterangepicker({
      'autoUpdateInput': false,
      'singleDatePicker': true,
      'timePicker': true,
      'timePicker24Hour': true,
      'locale': this.future_single_daterangepicker_locale(),
      'endDate': moment()
    }, function (start, end, label) { });
  }
}

$(function () {
  let picker_creator = new DateRangePickerCreator(locale);
  picker_creator.create_pickers('.date_range', {});
  picker_creator.create_pickers('.date_range_without_time', {
    'timePicker': false,
    'locale': picker_creator.daterangepicker_locale(picker_creator.short_date_format_config())
  });
  picker_creator.create_single_date_pickers('.single_date', {});
  picker_creator.create_single_date_pickers('.single_date_without_time', {
    'timePicker': false,
    'maxDate': false,
    'locale': picker_creator.daterangepicker_locale(picker_creator.short_date_format_config())
  });
  picker_creator.create_future_date_without_time_pickers('.future_single_date');
  $('.single_date').on('cancel.daterangepicker', function (ev, picker) {
    $(this).val('');
  });
  $('.single_date').on('apply.daterangepicker', function (ev, picker) {
    $(this).val(picker.startDate.format(picker_creator.daterangepicker_locale()['format']));
  });
  $('.single_date_without_time').on('cancel.daterangepicker', function (ev, picker) {
    $(this).val('');
  });
  $('.single_date_without_time').on('apply.daterangepicker', function (ev, picker) {
    $(this).val(picker.startDate.format(picker_creator.future_single_daterangepicker_locale()['format']));
  });
  $('.future_single_date').on('cancel.daterangepicker', function (ev, picker) {
    $(this).val('');
  });
  $('.future_single_date').on('apply.daterangepicker', function (ev, picker) {
    $(this).val(picker.startDate.format(picker_creator.future_single_daterangepicker_locale()['format']));
  });
});
